export const LEGAL_BUSINESS_CONSTANTS = {
  ALERT_DESCRIPTION:
    'The legal business information entered does not match your tax records. To avoid disruption of service, please update and click Submit.',
  DEFAULT_WEBSITE: 'https://www.vynedental.com',
  TCR_URL: 'https://vynedental.com/tcr/',
}
